
import alertBox from '@/components/alert-box.vue'
import { defineComponent } from 'vue'
import pageHead from '../components/page-head.vue'
import detail from './components/detail.vue'
import people from './components/people.vue'
import statistics from './components/statistics.vue'
import record from './components/record.vue'
import { getInsuranceDetail, InsuranceDetailDto, RenewDataDto, renewPolicy, renewPreview } from '@/api/insurance'
import global from '@/utils/global'
import router from '@/router'
import PlanRule from '@/views/index/components/plan-rule.vue'

export default defineComponent({
    name: 'InsuranceNew',
    components: {
        PlanRule,
        'page-head': pageHead,
        'component-detail': detail,
        'component-people': people,
        'component-statistics': statistics,
        'component-record': record,
        'alert-box': alertBox
    },
    data () {
        return {
            id: '',
            timeMonth: '',
            isExport: false,
            isRenew: false,
            exportType: 'date',
            detail: {} as InsuranceDetailDto,
            renewData: {} as RenewDataDto,
            renewPage: 1,
            renewPageSize: 5,
            isRenewPeople: false,
            showPlanRule: false
        }
    },
    async created () {
        this.id = this.$route.params.id as string
        const result = await getInsuranceDetail({
            policyId: this.$route.params.id as unknown as number
        })
        this.detail = result
    },
    methods: {
    // 关闭导出账单弹窗
        close () {
            this.isExport = false
        },
        // 导出账单
        async onExport () {
            if (!this.timeMonth) {
                this.$message.error('请选择月份')
                return
            }
            const api = this.exportType === 'person' ? '/policy/exportPersonBill/' : '/policy/exportBill/'
            window.location.href =
          process.env.VUE_APP_BASE_URL +
          api +
          '?month=' +
          this.timeMonth +
          '&policyId=' +
          this.id +
          '&token=' +
          global.token
            this.$message.success('导出成功')
            await this.close()
        },
        // 导出在保人员名单
        onExportActive () {
            window.location.href =
        process.env.VUE_APP_BASE_URL +
        '/policy/exportActive?policyId=' +
        this.id +
        '&token=' +
        global.token
            this.$message.success('导出成功')
        },
        // 点击一键续保
        async onRenew () {
            this.renewData = await renewPreview({
                policyId: this.detail.policy_id
            })
            this.isRenew = true
        },
        // 确定一键续保
        async onSubmitRenew () {
            await this.$util.confirm('操作提示', '是否确认续保？')
            await renewPolicy({
                policyId: this.detail.policy_id
            })
            this.isRenew = false
            this.isRenewPeople = false
            this.$message.success('续保成功！')
            // 刷新
            this.detail = await getInsuranceDetail({
                policyId: this.$route.params.id as unknown as number
            })
        },
        goAddSubtract (type: string) {
            if (this.detail.is_close === 1) {
                this.$message.warning('该保单已关闭，无法加减保')
                return
            }
            router.push({
                path: '/insurance/addsubtract/' + type + '/' + this.id
            })
        }
    }
})
